export default __webpack_public_path__ + "static/media/uba.046a1436.png";